(function (global, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (global) {
    global.DgDonationCarousel = api;

    if (global.document) {
      var boot = function (scope) {
        api.init(scope || global.document);
      };

      if (global.document.readyState === 'loading') {
        global.document.addEventListener('DOMContentLoaded', function () {
          boot(global.document);
        });
      } else {
        boot(global.document);
      }

      global.document.addEventListener('shopify:section:load', function (event) {
        boot(event.target);
      });
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function getSwipeStep(distance, threshold) {
    var minimumDistance = typeof threshold === 'number' ? threshold : 48;

    if (Math.abs(distance) < minimumDistance) return 0;
    return distance > 0 ? 1 : -1;
  }

  function wrapIndex(index, total) {
    if (!total) return 0;
    return ((index % total) + total) % total;
  }

  function render(root, requestedIndex) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-dg-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dg-dot]'));
    var total = slides.length;

    if (!total) return 0;

    var index = wrapIndex(requestedIndex, total);
    var activeSlide = slides[index];
    var track = root.querySelector('[data-dg-track]');
    var title = root.querySelector('[data-dg-title]');
    var text = root.querySelector('[data-dg-text]');

    root.dataset.currentIndex = String(index);

    if (track) {
      track.style.transform = 'translateX(' + (index * 100) + '%)';
    }

    if (title) title.textContent = activeSlide.dataset.title || '';
    if (text) text.textContent = activeSlide.dataset.text || '';

    slides.forEach(function (slide, slideIndex) {
      slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
    });

    dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    return index;
  }

  function move(root, step) {
    var current = Number.parseInt(root.dataset.currentIndex || '0', 10);
    return render(root, current + step);
  }

  function setup(root) {
    if (root.dataset.dgCarouselReady === 'true') return;
    root.dataset.dgCarouselReady = 'true';

    var viewport = root.querySelector('[data-dg-viewport]');
    var previous = root.querySelector('[data-dg-previous]');
    var next = root.querySelector('[data-dg-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dg-dot]'));
    var pointerStartX = null;

    render(root, Number.parseInt(root.dataset.currentIndex || '0', 10));

    if (previous) {
      previous.addEventListener('click', function () {
        move(root, -1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        move(root, 1);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        render(root, index);
      });
    });

    if (viewport) {
      viewport.addEventListener('pointerdown', function (event) {
        if (event.isPrimary === false) return;
        pointerStartX = event.clientX;
      });

      viewport.addEventListener('pointerup', function (event) {
        if (event.isPrimary === false || pointerStartX === null) return;

        var step = getSwipeStep(event.clientX - pointerStartX, 48);
        pointerStartX = null;

        if (step) move(root, step);
      });

      viewport.addEventListener('pointercancel', function () {
        pointerStartX = null;
      });
    }
  }

  function init(scope) {
    var roots = [];

    if (scope.matches && scope.matches('[data-dg-donation-carousel]')) {
      roots.push(scope);
    }

    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-dg-donation-carousel]')));
    roots.forEach(setup);
  }

  return {
    getSwipeStep: getSwipeStep,
    wrapIndex: wrapIndex,
    render: render,
    setup: setup,
    init: init,
  };
});
